<template>
  <div>
    <div class="ceiling">
      <home-top></home-top>
      <navicat background="#ffffff" :current="8"></navicat>
    </div>
    <!-- <div class="h-top"></div> -->
    <div class="content w-1400">
      <div class="bread-crumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/technology' }">技术项目交易</el-breadcrumb-item>
          <el-breadcrumb-item>详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-title">技术项目交易</div>
      <div class="content-body" v-loading="loading">
        <div class="body-left">
          <div class="left-header">
            <div class="header-left">
              <img v-if="detail.product" class="header-img" :src="detail.product.image" alt="产品图片"/>
              <div class="step-box">
                <el-steps :active="4" align-center>
                  <el-step title="发布供需"></el-step>
                  <el-step title="资源匹配"></el-step>
                  <el-step title="项目洽谈"></el-step>
                  <el-step title="项目成交"></el-step>
                </el-steps>
              </div>
            </div>
            <div class="header-right">
              <div class="right-top">
                <div class="title-tag" v-if="detail">
                  <span class="title-name" v-if="detail.product">{{
                      detail.product.name
                    }}</span>
                  <div class="tag-box bay" v-if="detail.type === 1">买技术</div>
                  <div class="tag-box" v-else>卖技术</div>
                  <!-- <el-tag type="info" effect="plain"
                    >项目编号：1234567890</el-tag
                  > -->
                </div>
                <div class="price-group">
                  <span class="price-name">价格</span>
                  <div class="price-num">
                    {{ detail.price == 0 ? "面议" : detail.price }}
                  </div>
                  <span v-if="detail.price != 0" class="price-name">元</span>
                </div>
              </div>
              <div class="right-middle">
                <table border="0" class="custom-table">
                  <tr>
                    <td>CAS号</td>
                    <td>{{ detail.cas_no }}</td>
                    <td>合作方式</td>
                    <td>{{ detail.co_type }}</td>
                  </tr>
                  <tr>
                    <td>所在地</td>
                    <td v-if="detail.address">
                      {{
                        detail.address.province +
                        detail.address.city +
                        detail.address.area
                      }}
                    </td>
                    <td>技术成熟度</td>
                    <td>{{ detail.tech_maturity }}</td>
                  </tr>
                  <tr>
                    <td>技术类型</td>
                    <td>{{ detail.tech_type == 1 ? "专利" : "非专利" }}</td>
                    <td>截止时间</td>
                    <td>{{ detail.upto_at }}</td>
                  </tr>
                </table>
              </div>
              <div class="right-bottom">
                <gradient-button @hit="handlePublish" width="170px" height="40px"
                                 background="#387DF6">发布供需
                </gradient-button>
                <gradient-button @hit="handleGetContact" width="216px" height="40px" background="#F3AD3E"
                                 border="1px solid #F3AD3E">免费获取联系方式
                </gradient-button>
                <gradient-button @hit="handleGuarantee" width="170px" height="40px" background="#E9F1FE" color="#387DF6"
                                 border="1px solid #336ED2">联系客服
                </gradient-button>
              </div>
            </div>
          </div>
          <div class="left-footer">
            <div class="p-box">声明</div>
            <div class="desc-info">
              技术项目交易信息由化联网平台注册用户自主发布，本平台为其提供免费线上展示服务。尽管所有信息均经过严格审核，但鉴于化学化工技术的复杂性和专业性，本平台无法完全保证技术类信息的真实性、可靠性及有效性。
            </div>
          </div>
        </div>
        <div class="body-right">
          <div class="right-title">最新交易</div>
          <div class="right-list">
            <pur-card v-for="(item, index) in goodsList" :key="index" :data="item"></pur-card>
          </div>
        </div>
      </div>
    </div>
    <!-- 担保咨询 -->
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false"
               :title="dialogTitle" :modal="false" top="20vh" :visible.sync="dialogVisible" width="30%"
               :before-close="handleClose">
      <span class="dialog-content" @click="copyText(dialogContent)">{{ dialogContent }} <i
          class="el-icon-copy-document"></i>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <home-footer></home-footer>
  </div>
</template>
<script>
import homeTop from "@/components/public/home-top.vue";
import navicat from "@/components/navicat/navicat.vue";
import purCard from "@/components/goods/pur-card.vue";
import gradientButton from "@/components/button/gradient-button.vue";
import {tech_detail, tech_list_api} from "@/api/modules/home";
import {getConfigByKey} from "@/api/modules/common";
import HomeFooter from "../../../components/public/home-footer.vue";
import {getMyCustomerService} from "../../../api";

export default {
  name: "technology-detail",
  components: {
    HomeFooter,
    homeTop,
    navicat,
    purCard,
    gradientButton,
  },
  data() {
    return {
      dialogVisible: false,
      dialogTitle: "",
      dialogContent: "",
      id: this.$route.query.id,
      detail: {},
      loading: true,
      hotline: "",
      goodsList: [],
      kefu: ''
    };
  },
  computed: {
    isLogin() {
      return this.$store.state.user.isLogin;
    },

    configInfo() {
      return this.$store.state.config.config;
    },
  },
  watch: {
    '$route.query.id': {
      handler(newVal) {
        this.id = newVal;
        this.getTechDetail();
        this.getTechList();
      },
    },
  },
  created() {
    this.getTechDetail();
    this.getTechList();
    this.init();
  },

  methods: {
    init() {
      getConfigByKey("hotline").then((res) => {
        this.hotline = res.data.data.value;
      });
      getMyCustomerService().then(res => {
        this.kefu = res.data.data.mobile
      })
    },
    copyText(text) {
      this.$utils.copyText(text, this);
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handlePublish() {
      this.$router.push({
        path: "/user/user-center",
      });
    },
    handleGetContact() {
      this.dialogVisible = true;
      this.dialogTitle = "免费获取联系方式";
      this.dialogContent = this.detail.people.mobile;
    },
    handleGuarantee() {
      this.dialogVisible = true;
      this.dialogTitle = "联系客服";
      this.dialogContent = this.kefu;
    },
    getTechDetail() {
      tech_detail(this.id).then((res) => {
        this.detail = res.data.data;
        this.loading = false;
      });
    },
    getTechList() {
      tech_list_api({
        page: 1,
        limit: 3,
      }).then((res) => {
        this.goodsList = res.data.data.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-content {
  display: block;
  font-size: 20px;
  text-align: center;
}

.h-top {
  // height: 142px;
  height: 120px;
}

.content {
  padding-bottom: 40px;

  .bread-crumb {
    margin: 20px 0;
  }

  .content-title {
    font-weight: 800;
    font-size: var(--font-size-default-big);
    color: #00112b;
    padding: 0 0 20px;
  }

  .content-body {
    display: flex;

    .body-right {
      width: 370px;
      // height: 815px;
      background: #ffffff;
      margin-left: 20px;
      padding: 20px;
      box-sizing: border-box;

      .right-title {
        font-weight: 800;
        font-size: var(--font-size-default-20);
        color: #00112b;
      }

      .right-list {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        gap: 20px;
      }
    }

    .body-left {
      width: 1010px;
      background: #ffffff;
      box-sizing: border-box;
      padding: 30px 20px 59px 40px;

      .left-header {
        display: flex;

        .header-left {
          .header-img {
            width: 300px;
            height: 300px;
            border: 1px solid #d8d8d8;
            object-fit: contain;
          }

          .step-box {
            ::v-deep .el-step__head.is-finish {
              border-color: #387df6;
            }

            ::v-deep .el-step__icon.is-text {
              border: 2px solid;
              border-color: inherit;
            }

            ::v-deep .el-step__title .is-finish {
              color: #5f616c;
              font-size: 14px;
              font-weight: 400;
            }

            ::v-deep .is-finish {
              .el-step__icon {
                background-color: #387df6;
                color: #ffffff;
              }
            }

            ::v-deep .el-step__title {
              font-size: 14px;
              color: #5f616c;
              font-weight: 400;
            }

            ::v-deep .el-step__head.is-process {
              .el-step__icon {
                // background-color: #387DF6;
                color: #c0c4cc;
                border: 2px solid #c0c4cc;
              }
            }
          }
        }

        .header-right {
          width: 100%;
          margin-left: 20px;

          .right-top {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title-tag {
              display: flex;
              align-items: center;
              width: 350px;

              .title-name {
                font-weight: 800;
                font-size: var(--font-size-default-20);
                color: #00112b;
              }

              .tag-box {
                margin: 0 20px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                font-weight: 400;
                font-size: 14px;
                padding: 2px 5px;
                color: #ffffff;
                background: #3860f4;
                border-radius: 3px 3px 3px 3px;
                margin-left: 10px;
              }

              .bay {
                background: #6ac9a9 !important;
              }
            }

            .price-group {
              display: flex;
              align-items: baseline;

              .price-name {
                font-weight: 400;
                font-size: 18px;
                color: #5f616c;

              }

              .price-num {
                font-weight: bold;
                font-size: 30px;
                color: #ec1b1b;
                margin-left: 20px;
              }
            }
          }

          .right-middle {
            margin: 20px 0 30px;
            background: #f9faff;

            .custom-table {
              width: 100%;
              font-size: var(--font-size-default-16);
              border-collapse: collapse;

              /* 关键：合并边框 */
              /* 新增样式规则 */
              td:nth-child(1),
              td:nth-child(3) {
                width: 110px;
                height: 65px;
                text-align: right;
                line-height: 65px;
                font-weight: 400;
                color: #5f616c;
              }

              td:nth-child(2),
              td:nth-child(4) {
                height: 65px;
                line-height: 65px;
                padding-left: 33px;
                font-weight: bold;
                color: #00112b;
              }
            }
          }

          .right-bottom {
            display: flex;
            justify-content: space-around;
            gap: 20px;
          }
        }
      }

      .left-footer {
        color: #5f616c;
        box-sizing: border-box;
        // width: 952px;
        margin-top: 75px;
        height: 111px;
        background: #f9faff;
        padding: 26px 30px;

        .p-box {
          font-weight: bold;
          font-size: var(--font-size-default-16);
        }

        .desc-info {
          font-weight: 400;
          font-size: 16px;
        }
      }
    }
  }
}
</style>
